import { ADD_ON_TAX, GENERAL_DISCOUNT, GLASS_PRICE_FACTOR_VALUE, GLASS_PRICE_MIN, PREMIUM_TAX, SECURITY_DEVICE_DISCOUNT, BIKE_PRICE_MIN_FACTOR_VALUE, RECOMMENDED_INSURED_SUM_FACTOR_VALUE, PREMIUM_FACTOR_VALUE, BIKE_PRICE_FACTOR_VALUE, contributionRatesByPostcode, } from '../rates';
export var isValidPostcode = function (postcode) {
    var formattedPostcode = formatPostcode(postcode);
    return contributionRatesByPostcode[formattedPostcode] ? true : false;
};
export var formatPostcode = function (postcode) {
    var firstDigit = postcode.split('')[0];
    if (firstDigit === '0') {
        return postcode.slice(1);
    }
    return postcode;
};
// Discount
export var getGeneralDiscountedPrice = function (price) {
    return price - price * GENERAL_DISCOUNT;
};
export var getSecurityDeviceDiscountedPrice = function (price) {
    return price - price * SECURITY_DEVICE_DISCOUNT;
};
// Monthly price
export var getMonthlyPrice = function (price) { return price / 12; };
// Taxes
export var getTaxedPremium = function (price) { return price * PREMIUM_TAX; };
export var getTaxedAddOn = function (price) { return price * ADD_ON_TAX; };
// Calculate premium
export var getPremium = function (contributionRate, insuredSum) { return (contributionRate * insuredSum) / PREMIUM_FACTOR_VALUE; };
export var getFinalPremium = function (contributionRate, insuredSum, hasSecurityDevice) {
    var premium = getGeneralDiscountedPrice(getPremium(contributionRate, insuredSum));
    if (hasSecurityDevice) {
        premium = getSecurityDeviceDiscountedPrice(premium);
    }
    return getMonthlyPrice(getTaxedPremium(premium));
};
// Recommended insured sum
export var getRecommendedInsuredSum = function (propertyInSqMeters) {
    return propertyInSqMeters * RECOMMENDED_INSURED_SUM_FACTOR_VALUE;
};
// Get the corresponding insured sum for a given target price, postcode and discount
export var calculateInsuredSumFromPrice = function (targetPrice, postcode, hasSecurityDevice) {
    var generalDiscountFactor = 1 - GENERAL_DISCOUNT;
    var securityDeviceDiscountFactor = hasSecurityDevice
        ? 1 - SECURITY_DEVICE_DISCOUNT
        : 1;
    if (!isValidPostcode(postcode)) {
        return null;
    }
    var formattedPostcode = formatPostcode(postcode);
    var basicContributionRate = contributionRatesByPostcode[formattedPostcode].basic;
    return ((targetPrice * 12 * PREMIUM_FACTOR_VALUE) /
        generalDiscountFactor /
        securityDeviceDiscountFactor /
        PREMIUM_TAX /
        basicContributionRate);
};
// Add-ons
export var getGlassPrice = function (propertyInSqMeters) {
    var factoredPrice = propertyInSqMeters * GLASS_PRICE_FACTOR_VALUE;
    return Math.max(factoredPrice, GLASS_PRICE_MIN);
};
export var getFinalGlassPrice = function (propertyInSqMeters, hasSecurityDevice) {
    var price = getGeneralDiscountedPrice(getGlassPrice(propertyInSqMeters));
    if (hasSecurityDevice) {
        price = getSecurityDeviceDiscountedPrice(price);
    }
    return getMonthlyPrice(getTaxedAddOn(price));
};
export var getBikePrice = function (_a) {
    var insuredSum = _a.insuredSum, bikeInsuredSum = _a.bikeInsuredSum, bikeContributionRate = _a.bikeContributionRate;
    return ((bikeInsuredSum - insuredSum * BIKE_PRICE_MIN_FACTOR_VALUE) /
        BIKE_PRICE_FACTOR_VALUE) *
        bikeContributionRate;
};
export var getFinalBikePrice = function (_a) {
    var insuredSum = _a.insuredSum, bikeInsuredSum = _a.bikeInsuredSum, bikeContributionRate = _a.bikeContributionRate, hasSecurityDevice = _a.hasSecurityDevice;
    var price = getGeneralDiscountedPrice(getBikePrice({ insuredSum: insuredSum, bikeInsuredSum: bikeInsuredSum, bikeContributionRate: bikeContributionRate }));
    if (hasSecurityDevice) {
        price = getSecurityDeviceDiscountedPrice(price);
    }
    return getMonthlyPrice(getTaxedAddOn(price));
};
export var getNearestCentRoundedValue = function (price) {
    return Math.round((price + Number.EPSILON) * 100) / 100;
};
